const selectCurrentPageSelector = (state) => {
    const { currentPage } = state;
    return currentPage;
};

export default selectCurrentPageSelector;
